module.exports = __webpack_public_path__ + "img/dian.7f349d6e.png";